import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { IconEmptySquare } from '../../components/Icon';

type SelectAllToggleProps = {
    selected: boolean;
    onClick?: () => void;
};

const SelectAllToggleRenderer = ({ selected, onClick }: SelectAllToggleProps): JSX.Element => {
    return (
        <div
            className="component-select-row-renderer"
            onClick={onClick}
        >
            {selected ? (
                <FontAwesomeIcon
                    icon={faCheck}
                    color="#2BB842"
                    size="lg"
                    style={{ strokeWidth: 30, stroke: '#2BB842' }}
                />
            ) : (
                <IconEmptySquare />
            )}
        </div>
    );
};

export default SelectAllToggleRenderer;
